import {
  AppstoreOutlined,
  BookOutlined,
  CreditCardOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  DollarOutlined,
  IdcardOutlined,
  NotificationOutlined,
  ScheduleOutlined,
  ShopOutlined,
  TagOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { ItemType } from "antd/es/menu/interface";

export const adminMenuItems: ItemType[] = [
  {
    key: "2",
    icon: <DatabaseOutlined />,
    label: "Maestros",
    children: [
      { key: "2.1", icon: <TeamOutlined />, label: <Link to="/clientes">Clientes</Link> },
      { key: "2.2", icon: <AppstoreOutlined />, label: <Link to="/productos">Productos</Link> },
      {
        key: "2.3",
        icon: <CreditCardOutlined />,
        label: <Link to="/formas-pago">Formas de pago</Link>,
      },
      { key: "2.4", icon: <BookOutlined />, label: <Link to="/colegios">Colegios</Link> },
      { key: "2.5", icon: <ShopOutlined />, label: <Link to="/tpvs">Tiendas</Link> },
      {
        key: "2.6",
        icon: <DollarOutlined />,
        label: <Link to="/precios-venta">Precios de venta</Link>,
      },
      { key: "2.7", icon: <TagOutlined />, label: <Link to="/cupones">Cupones activos</Link> },
      { key: "2.8", icon: <NotificationOutlined />, label: <Link to="/campanas">Campañas</Link> },
      { key: "2.9", icon: <IdcardOutlined />, label: <Link to="/vendedores">Vendedores</Link> },
      // Cajas y Turnos viven acá y no en un submenú propio: son catálogos que
      // se sincronizan de Business Central, como los otros nueve, no
      // movimientos --eso es Gestión--. Y una caja pertenece a una tienda, que
      // ya estaba en esta lista: tenerlas separadas repartía padre e hijo en
      // dos sitios del menú.
      //
      // Van al final, con claves nuevas, y no junto a Tiendas que es donde
      // encajarían mejor: eso obligaría a renumerar de 2.6 a 2.9, y **Paraguay
      // esconde el ítem «2.9»** para ocultar Vendedores. Renumerar sin mover
      // esa regla haría que Paraguay escondiera la pantalla equivocada, en
      // silencio y sólo en un país.
      { key: "2.10", icon: <DesktopOutlined />, label: <Link to="/cajas">Cajas</Link> },
      { key: "2.11", icon: <ScheduleOutlined />, label: <Link to="/turnos">Turnos</Link> },
    ] as any[],
  },
  {
    key: "7",
    icon: <UserOutlined />,
    label: <Link to="/usuarios">Usuarios</Link>,
  },
];
